import { useSendPageViewEvent } from '@ui-common/hooks'

import { useAnalyticsService } from '../state/analyticsContext'
import { StepType } from '../wizard/wizardSteps'

export const useSendSecLoansPageViewEvent = (name: StepType): void => {
  const { analyticsService } = useAnalyticsService()
  useSendPageViewEvent(analyticsService, name)
}
